import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { actionTaskSuccess } from "../crud/ohCase/actions";

import { SEND_LETTER_TO_GP_SPECIALIST, WRITE_TO_GP_SPECIALIST } from "./actionTypes";
import { generalPractitionerSpecialistApi } from "./gpSpecialistInfoApi";
import { SendLetterToGPSpecialistModel, WriteToGPSpecialistModel } from "./models";

export const writeToGPSpecialist = (customerId: string, ohCaseId: string, taskId: string, model: WriteToGPSpecialistModel) => {
    return async (dispatch: Dispatch) => {
        const updatedTasks = await loadAndTrack(
            dispatch,
            WRITE_TO_GP_SPECIALIST,
            generalPractitionerSpecialistApi.writeToGPSpecialist(customerId, ohCaseId, taskId, model)
        );
        dispatch(actionTaskSuccess({ ohCaseId, tasks: updatedTasks }));
    };
};

export const sendLetterToGPSpecialist = (customerId: string, ohCaseId: string, taskId: string, model: SendLetterToGPSpecialistModel) => {
    return async (dispatch: Dispatch) => {
        const updatedTasks = await loadAndTrack(
            dispatch,
            SEND_LETTER_TO_GP_SPECIALIST,
            generalPractitionerSpecialistApi.sendLetterToGPSpecialist(customerId, ohCaseId, taskId, model)
        );
        dispatch(actionTaskSuccess({ ohCaseId, tasks: updatedTasks }));
    };
};
